module.exports = __webpack_public_path__ + "img/Leadership.81c3c10f.png";